import {Component} from 'react';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import ReduxVip from "../store/actionreducers/vip";
import ReduxMission from "../store/actionreducers/mission";

class PollingTool extends Component {

    pollingWrapper = (fn) => {
        if (!fn) return;
        setTimeout(async () => {
            await fn();
            this.pollingWrapper(fn);
        }, 10 * 1000);
    };

    async componentDidMount() {

        // this.pollingWrapper(this.props.getVips);
        // this.pollingWrapper(this.props.getMissions);
    }

    render() {
        return '';
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getVips: ReduxVip.ActionCreator.getVips,
        getMissions: ReduxMission.ActionCreator.getMissions,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(PollingTool);



// WEBPACK FOOTER //
// ./src/main/PollingTool.js